<template>
    <div class="coupon-list" v-if="couponList && couponList.length && !isSourceChannel" @click="openCouponList">
        <div class="title">
            领优惠券
        </div>
        <div class="coupon-view-container">
            <div class="coupon-view">
                <div class="coupon" ref="coupon">
                    <span v-for="item in couponList" :key="item.couponId" class="production-coupon">
                        {{ item.couponInfo }}
                    </span>
                </div>
                <div v-if="showOverMask" class="over-mask"></div>
            </div>
            <img src="https://imgcdn.chuxingyouhui.com/blackunique/upload/452c27560e62836913046c22bebd368f.png" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CouponList',
    data() {},
    computed: {},
    props: {
        couponList: {
            type: Array,
            default: () => [],
        },
        isSourceChannel: {
            type: Boolean,
            default: false,
        },
        showOverMask: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        openCouponList() {
            this.$emit('open');
        },
    },
};
</script>
<style lang="scss" scoped>
.coupon-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem;
    box-sizing: border-box;
    width: 7.02rem;
    height: 0.72rem;
    background: #fff;
    border-radius: 0.16rem;
    margin: 0.16rem auto 0.16rem auto;
    img {
        margin-left: 0.08rem;
        width: 0.14rem;
        height: 0.24rem;
    }
    .title {
        line-height: 0.4rem;
        font-size: 0.28rem;
        font-weight: 600;
        color: #252220;
    }
    .coupon-view-container {
        display: flex;
        align-items: center;
        .coupon-view {
            position: relative;
            overflow: hidden;

            .over-mask {
                width: 10%;
                height: 100%;
                background: linear-gradient(90deg, rgba(255, 255, 255, 0), white);
                position: absolute;
                bottom: 0;
                right: 0;
                z-index: 1;
            }
            .coupon {
                text-align: right;
                white-space: nowrap;
                transform: unset;
                width: 100%;
                font-size: 0.22rem;
                &:last-child {
                    margin-right: 0;
                }
            }
            .production-coupon {
                position: relative;
                display: inline-block;
                margin-right: 0.12rem;
                height: 0.36rem;
                line-height: 0.36rem;
                border: none;
                border-radius: 0.04rem;
                padding: 0 0.16rem;
                color: #fff;
                background: #ff4b21;
                &::before {
                    content: '';
                    position: absolute;
                    width: 0.1rem;
                    height: 0.2rem;
                    top: 0.1rem;
                    left: -0.02rem;
                    background: #fff;
                    border-radius: 0 0.1rem 0.1rem 0;
                }
                &::after {
                    content: '';
                    position: absolute;
                    width: 0.1rem;
                    height: 0.2rem;
                    top: 0.1rem;
                    right: -0.02rem;
                    background: #fff;
                    border-radius: 0.1rem 0 0 0.1rem;
                }
                &:last-child {
                    margin-right: 0.01rem;
                }
            }
        }
        img {
            width: 0.32rem;
            height: 0.32rem;
        }
    }
    .icon {
        width: 1.04rem;
        height: 0.36rem;
        background: linear-gradient(301deg, #3b230f 0%, #572f11 49%, #301601 100%);
        border-radius: 0.06rem;
        flex-shrink: 0;

        background: url(https://imgcdn.chuxingyouhui.com/blackunique/upload/0a364726e478f9b2ab344e3f571feb53.png)
            no-repeat center;
        background-size: contain;
    }
    .tip {
        padding-left: 0.12rem;
        height: 0.32rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.32rem;
        flex: 1;
        b {
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #ff460f;
            display: inline-block;
            margin: 0 0.04rem;
        }
    }
    .rewards-desc {
        height: 0.32rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.32rem;

        display: flex;
        align-items: center;
        .icon-q {
            width: 0.28rem;
            height: 0.28rem;
            flex-shrink: 0;
            margin-left: 0.04rem;
            background: url(https://imgcdn.chuxingyouhui.com/blackunique/upload/00b6d2da5a887d9449843af3a8478a93.png)
                no-repeat center;
            background-size: contain;
        }
    }
}
</style>
